import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TooltipTableHeadComponent } from "../../common/TableHead";
import {
  buildStreamParameterTooltips,
  formatStreamParameterValue,
} from "./EditCameraUtils/streamParameterFields";

export const StreamParametersTab = ({
  streamParametersData,
  siteInfo,
}: {
  streamParametersData: any;
  siteInfo?: { protocol?: string | null };
}) => {
  const extraFields = streamParametersData.extra_fields;

  // The integration writes a helperText for each field (actuate_admin's
  // list_extra_camera_fields); surface it on the header rather than dropping it.
  const titlesArray = extraFields.map((field: any) => [
    field.label,
    field.field,
  ]);
  const toolTipText = buildStreamParameterTooltips(extraFields);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 1000, fontFamily: "Mulish" }}>
        <TooltipTableHeadComponent
          titlesArray={titlesArray}
          toolTipText={toolTipText}
        />
        <TableBody>
          <TableRow key={`stream_parameters`}>
            {extraFields.map((object: any) => (
              <TableCell key={object.id} align="left">
                {formatStreamParameterValue(
                  streamParametersData[object.field],
                  object.type,
                  object.options,
                  {
                    field: object.field,
                    label: object.label,
                    siteProtocol: siteInfo?.protocol,
                  }
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
